import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { postData } from "../../../utility/Utility";
import { toast, ToastContainer } from "react-toastify";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function AddDesignation() {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.designation || null;

  const [formData, setFormData] = useState({
    currentRole: "",
    targetRole: "",
    count: "",
    childRoleToCount: ""
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      setFormData({
        currentRole: editData.currentRole || "",
        targetRole: editData.targetRole || "",
        count: editData.count || "",
        childRoleToCount: editData.childRoleToCount || ""
      });
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        currentRole: formData.currentRole.trim(),
        targetRole: formData.targetRole.trim(),
        count: parseInt(formData.count),
        childRoleToCount: formData.childRoleToCount,
      };

      let endpoint = "/api/promotionCtrl/create";
      if (editData) {
        payload.id = editData._id;
        endpoint = "/api/promotionCtrl/update";
      }

      const response = await postData(endpoint, payload);

      if (response?.success) {
        toast.success(editData ? "Promotion updated successfully" : "Promotion created successfully");
        navigate("/designation-list");
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error saving promotion:", error);
      toast.error("Server error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={5000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          {/* Header & Breadcrumbs */}
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <h4 className="page-title mb-0">
              {editData ? "Update Designation" : "Add Designation"}
            </h4>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => navigate("/designation-list")}
              disabled={loading}
            >
              <i className="fas fa-arrow-left me-1"></i> Back
            </button>
          </div>

          {/* Form Card */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">
                    {editData ? "Update Designation" : "Create New Designation"}
                  </h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* Current Role */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="currentRole" className="form-label fw-medium">
                         Current Role <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <select
                          id="currentRole"
                          name="currentRole"
                          className="form-select"
                          value={formData.currentRole}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Current Role</option>
                          <option value="FIELD OFFICER">Field Officer</option>
                          <option value="FIELD DEVELOPMENT OFFICER">Field Development Officer</option>
                          <option value="SENIOR FIELD DEVELOPMENT OFFICER">Senior Field Development Officer</option>
                          <option value="MANAGER">Manager</option>
                          <option value="DIRECTOR">Director</option>
                          <option value="OPERATIONAL DIRECTOR">Operational Director</option>
                        </select>
                      </div>  
                    </div>

                    {/* Target Role */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="targetRole" className="form-label fw-medium">
                          Target Role <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <select
                          id="targetRole"
                          name="targetRole"
                          className="form-select"
                          value={formData.targetRole}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Target Role</option>
                          <option value="FIELD OFFICER">Field Officer</option>
                          <option value="FIELD DEVELOPMENT OFFICER">Field Development Officer</option>
                          <option value="SENIOR FIELD DEVELOPMENT OFFICER">Senior Field Development Officer</option>
                          <option value="MANAGER">Manager</option>
                          <option value="DIRECTOR">Director</option>
                          <option value="OPERATIONAL DIRECTOR">Operational Director</option>
                        </select>
                      </div>
                    </div>

                    {/* Count */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="count" className="form-label fw-medium">
                          Required Agent <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="number"
                          id="count"
                          name="count"
                          className="form-control"
                          placeholder="Enter required agent count -For example: 1"
                          value={formData.count}
                          onChange={handleInputChange}
                          min="0"
                          required
                        />
                      </div>
                    </div>

                    {/* Child Role Count */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-3">
                        <label htmlFor="childRoleToCount" className="form-label fw-medium">
                          Child Role Name <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-md-6">
                        <select
                          id="childRoleToCount"
                          name="childRoleToCount"
                          className="form-select"
                          value={formData.childRoleToCount}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Child Role Name</option>
                          <option value="FIELD OFFICER">Field Officer</option>
                          <option value="FIELD DEVELOPMENT OFFICER">Field Development Officer</option>
                          <option value="SENIOR FIELD DEVELOPMENT OFFICER">Senior Field Development Officer</option>
                          <option value="MANAGER">Manager</option>
                          <option value="DIRECTOR">Director</option>
                          <option value="OPERATIONAL DIRECTOR">Operational Director</option>
                        </select>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="row mt-4">
                      <div className="col-md-6 offset-md-3">
                        <button
                          type="submit"
                          className="btn btn-primary py-2"
                          disabled={loading}
                        >
                          {loading ? "Processing..." : (editData ? "Update" : "Submit")}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddDesignation;